import { useEffect, useMemo, useState, useCallback } from "react";
import { GetAllOrder } from "../../services/orderService";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule } from "ag-grid-community";
import "ag-grid-community/styles/ag-theme-quartz.css";

import CommonGridHeader from "../../common/CommonGridHeader";
import { useNavigate } from "react-router-dom";


const modules = [AllCommunityModule];
//const modules = useMemo(() => [AllCommunityModule], []);
const today = new Date().toISOString().split("T")[0];
const AllOrders = () => {
    const userid = localStorage.getItem("userid");
    const [loading, setLoading] = useState(false);
    const [allRows, setAllRows] = useState([]);
    const [expandedRows, setExpandedRows] = useState({});
    const [error, setErrors] = useState("");
    const [selectedFields, setSelectedFields] = useState([]);
    const navigate = useNavigate();
    const mapOrders = useCallback((orders = []) => {
        const rows = [];

        orders.forEach(order => {
            rows.push({
                id: order.id,
                orderType: order.orderType,
                dateCreated: order.dateCreated
                    ? new Date(order.dateCreated).toLocaleString()
                    : "",
                firstName: order.firstName,
                lastName: order.lastName,
                email: order.email,
                mobile: order.mobile,
                address: order.address,
                address2: order.address2,
                landMark: order.landMark,
                state: order.state,
                city: order.city,
                postalCode: order.postalCode,
                servicability: order.servicability,
                paymentName: order.payment?.name || "",
                diseaseName: order.issueDisease?.name || "",
                discount: order.discount,
                shiping: order.shiping,
                gTotal: order.gTotal,
                rowId: `parent-${order.id}`,
                type: "parent",
                hasChildren: order.getOrderItemDtos?.length > 0,
            });

            order.getOrderItemDtos?.forEach((item, index) => {
                rows.push({
                    id: item.id,
                    productName: item.productName,
                    quantity: item.quantity,
                    priceAtPurchase: item.priceAtPurchase,
                    parentId: order.id,
                    rowId: `child-${order.id}-${index}`,
                    type: "child",
                });
            });
        });

        return rows;
    }, []);


    const loadOrders = useCallback(async (startDate = today, endDate = today) => {
        try {
            setLoading(true);

            const response = await GetAllOrder(
                Number(userid),
                startDate,
                endDate
            );

            if (response?.statusCode === 200 && response.success) {
                setErrors("");
                setAllRows(mapOrders(response.data));
            } else {
                setErrors(response?.message || "Something went wrong");
            }
        } catch (err) {
            setErrors(err.message);
        } finally {
            setLoading(false);
        }
    }, [userid, mapOrders]);

    useEffect(() => {
        loadOrders();
    }, [loadOrders]);


    // Expand / Collapse
    const toggleExpand = useCallback((id) => {
        setExpandedRows((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    }, []);

    // Visible Rows
    const rowData = useMemo(() => {
        return allRows.filter((row) => {
            if (row.type === "parent") return true;

            return expandedRows[row.parentId];
        });
    }, [allRows, expandedRows]);

    // Expand Button Renderer
    const ExpandCell = useCallback(
        (props) => {
            const row = props.data;

            if (
                row.type === "child" ||
                !row.hasChildren
            ) {
                return null;
            }

            return (
                <button
                    onClick={() =>
                        toggleExpand(row.id)
                    }
                    style={{
                        border: "none",
                        background: "transparent",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "bold",
                    }}
                >
                    {expandedRows[row.id]
                        ? "−"
                        : "+"}
                </button>
            );
        },
        [expandedRows, toggleExpand]
    );
    const [selectedOrderIds, setSelectedOrderIds] = useState([]);
const EditButtonRenderer = useCallback(
        (props) => {
            const row = props.data;

            if (row.type !== "parent") {
                return null;
            }

            return (
                <button
                    className="btn btn-sm btn-primary"
                    onClick={() => navigate(`/orders/edit/${row.id}`)}
                >
                    Edit
                </button>
            );
        },
        [navigate]
    );

    const columnDefs = useMemo(
        () => [
            {
                field: "__edit",
                headerName: "Action",
                width: 110,
                sortable: false,
                filter: false,
                pinned: "left",
                cellRenderer: EditButtonRenderer,
            },
            {
                field: "__expand",
                headerName: "",
                width: 40,
                cellRenderer: ExpandCell,
                sortable: false,
                filter: false,
            },

            {
                field: "id",
                headerName: "ID",
                width: 90,
            },
            {
                field: "dateCreated",
                headerName: "Date Created",
                width: 160,
            },
            { field: "orderType", headerName: "Order Type", width: 120 },
            {
                field: "firstName",
                headerName: "Customer Name",
                width: 120,

                valueGetter: (params) => {
                    if (
                        params.data.type ===
                        "parent"
                    ) {
                        return `${params.data.firstName} ${params.data.lastName}`;
                    }

                    return "Order Item";
                },

                cellStyle: (params) => ({
                    paddingLeft:
                        params.data.type ===
                            "child"
                            ? "40px"
                            : "10px",

                    fontWeight:
                        params.data.type ===
                            "parent"
                            ? "bold"
                            : "normal",
                }),
            },

            {
                field: "email",
                headerName: "Email",
                //flex: 1,
                width: 140,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.email
                        : "",
            },

            {
                field: "mobile",
                headerName: "Mobile",
                width: 140,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.mobile
                        : "",
            },

            {
                field: "address",
                headerName: "Address",
                //flex: 1,
                width: 200,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.address
                        : "",
            },
            {
                field: "state",
                headerName: "State",
                width: 100,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.state
                        : "",
            },
            {
                field: "city",
                headerName: "City",
                width: 130,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.city
                        : "",
            },

            {
                field: "postalCode",
                headerName: "Pincode",
                width: 130,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.postalCode
                        : "",
            },
            {
                field: "servicability",
                headerName: "Servicability",
                width: 130,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.servicability
                        : "",
            },

            {
                field: "paymentName",
                headerName: "Payment",
                width: 130,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.paymentName
                        : "",
            },

            {
                field: "diseaseName",
                headerName: "Disease",
                width: 170,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.diseaseName
                        : "",
            },

            {
                field: "discount",
                headerName: "Discount",
                width: 120,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.discount
                        : "",
            },

            {
                field: "shiping",
                headerName: "Shipping",
                width: 120,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.shiping
                        : "",
            },

            {
                field: "gTotal",
                headerName: "Grand Total",
                width: 150,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.gTotal
                        : "",
            },

            // ================= CHILD ROW DATA =================

            {
                field: "productName",
                headerName: "Product",
                width: 180,

                valueGetter: (params) =>
                    params.data.type ===
                        "child"
                        ? params.data.productName
                        : "",
            },

            {
                field: "quantity",
                headerName: "Qty",
                width: 100,

                valueGetter: (params) =>
                    params.data.type ===
                        "child"
                        ? params.data.quantity
                        : "",
            },

            {
                field: "priceAtPurchase",
                headerName: "Price",
                width: 120,

                valueGetter: (params) =>
                    params.data.type ===
                        "child"
                        ? params.data.priceAtPurchase
                        : "",
            },
        ],
        [ExpandCell,EditButtonRenderer]
    );

    //implement header fields
    const defaultFields = useMemo(
        () =>
            columnDefs
                .map(col => col.field)
                .filter(Boolean),
        [columnDefs]
    );

    useEffect(() => {
        setSelectedFields(defaultFields);
    }, [defaultFields]);

    const handleFieldChange = (field) => {
        setSelectedFields(prev =>
            prev.includes(field)
                ? prev.filter(x => x !== field)
                : [...prev, field]
        );
    };
    const handleReset = () => {
        setSelectedFields(defaultFields);
    };
    const visibleColumnDefs = useMemo(() => {
        return columnDefs.filter(col => selectedFields.includes(col.field));
    }, [columnDefs, selectedFields]);
    // end here
    const headerFields = useMemo(
        () =>
            columnDefs
                .filter(col => col.field)
                .map(col => ({
                    key: col.field,
                    label: col.headerName || col.field,
                })),
        [columnDefs]
    );

    

    return (

        <div className="container-fluid py-3">

            <div className="d-flex justify-content-between align-items-center mb-4">
                <h4> Order List</h4>
            </div>
            {loading && (
                <div className="text-center">
                    Loading...
                </div>
            )}

            <CommonGridHeader
                fields={headerFields}
                selectedFields={selectedFields}
                onFieldChange={handleFieldChange}
                onReset={handleReset}
                startDate={today}
                endDate={today}
            />
            {error && (
                <div className="alert alert-danger">
                    {error}
                </div>
            )}
            <AgGridReact
                modules={modules}
                rowData={rowData}
                columnDefs={visibleColumnDefs}
                context={{
                    allRows,
                    selectedOrderIds,
                    setSelectedOrderIds,
                }}
                pagination={true}
                paginationPageSize={10}
                rowHeight={45}
                animateRows={true}
                domLayout="autoHeight"
                getRowId={(params) =>
                    params.data.rowId
                }

                getRowStyle={(params) => {
                    if (params.data.type === "child") {
                        return {
                            background: "#f8f9fa",
                        };
                    }
                }}
            />
        </div>
    );
};

export default AllOrders;